<template>
  <div class="groupComp">
    <nav-local-comp :all="'Группы'" :id="id" :toAll="toAll"/>
    <tabs-comp :moduleName="moduleName"/>
    <group-crud-comp v-if="tabs.group.active"/>
    <group-promocode-crud-comp v-if="tabs.promocode.active"/>
    <!-- <users-comp v-if="tabs.users.active && id" :params="{groupId: id}"/> -->
    <users-comp
      v-if="tabs.users.active && id"
      :onFilter="true"
      :required="[
        'userGroup',
        'id',
        'phone',
        'repost',
        'bonus',
        'sale',
        'bonusDate',
        'ordersCount',
        'ordersBonus',
        'ordersPrice'
      ]"
      :groupId="Number(id)"
    />
    <div v-if="tabs.users.active && !id" class="div_nodata">
      <label class="label_nodata">Сначала создайте группу</label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'groupComp',
  props: {
  },
  data: function () {
    return {
      moduleName: 'groups',
      required: null
    }
  },
  created: function () {
    this.$store.dispatch(`${this.moduleName}/getOne`, { required: this.required })
  },
  components: {
  },
  computed: {
    id: function () { return this.$store.getters[`${this.moduleName}/getId`] },
    tabs: function () { return this.$store.getters[`${this.moduleName}/getTabs`] }
  },
  methods: {
    toAll () {
      this.$store.dispatch(`${this.moduleName}/toAll`)
    }
  }
}
</script>

<style scoped lang="scss">

@media screen and (max-width: 1140px){
}
@media screen and (max-width: 960px){
}
@media screen and (max-width: 720px){
}
@media screen and (max-width: 540px){
}
@media screen and (max-width: 480px){
}
@media screen and (max-width: 320px){
}

</style>
